module.exports = __webpack_public_path__ + "static/lato-latin-900.26db7604.woff";


//////////////////
// WEBPACK FOOTER
// ./~/typeface-lato/files/lato-latin-900.woff
// module id = ./node_modules/typeface-lato/files/lato-latin-900.woff
// module chunks = 17241999800008180000